import { render, staticRenderFns } from "./left-sidebar.vue?vue&type=template&id=46fc7af8&scoped=true&"
import script from "./left-sidebar.vue?vue&type=script&lang=js&"
export * from "./left-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./left-sidebar.vue?vue&type=style&index=0&id=46fc7af8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc7af8",
  null
  
)

export default component.exports